import { Card, Col, Form, Input, InputNumber, Modal, Row } from "antd"
import { CustomBtn } from "../../../../components/commonComponents"
import { addDocumentHierarchy, updateDocumentHierarchy } from "../actions"
import { useEffect } from "react"

export const DocumentHierarchyModal = ({ open, close, data, reload }) => {
    const [form] = Form.useForm()
    const saveData = () => {
        if(data){
            updateDocumentHierarchy(form.getFieldsValue(),data.id).then(() => {
                reload()
                close(false)
            }).catch((error) => {
                console.log(error)
            })
        }else{
            addDocumentHierarchy(form.getFieldsValue()).then(() => {
                reload()
                close(false)
            }).catch((error) => {
                console.log(error)
            })
        }
    }
    useEffect(() => {
        if(data){
            form.setFieldsValue(data)
        }
    }, [data])
    return (
        <Modal
            title={data ? "რედაქტირება" : "დოკუმენტების სტრუქტურის დამატება"}
            open={open}
            onCancel={() => close(false)}
            footer={[
                <CustomBtn key="submit" label="დამატება" onClick={form.submit} color="green" icon={<i className="fa-solid fa-circle-plus"></i>} colorHover={'#135200'} htmlType="submit" />,
                <CustomBtn key="cancel" label="დახურვა" onClick={() => {
                    close(false)
                }} color="gray" icon={<i className="fa-solid fa-circle-xmark"></i>} colorHover={'#000'} />
            ]}
        >
            <Card>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={saveData}
                >
                    <Row gutter={[10, 10]}>
                        <Col span={12}>
                            <Form.Item
                                label="საფეხური"
                                name="step"
                                rules={[
                                    { required: true, message: 'ველი აუცილებელია' }
                                ]}
                            >
                                <InputNumber style={{width: '100%'}} min={1} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="კოდი"
                                name="code"
                                rules={[
                                    { required: true, message: 'ველი აუცილებელია' }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="დასახელება"
                                name="name"
                                rules={[
                                    { required: true, message: 'ველი აუცილებელია' }
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </Modal>
    )
}